module.exports = __webpack_public_path__ + "static/img/children10.c49ca2c2.jpeg";